import { createContext } from "react";

interface GlobalContextProps {
  setEnableOrderSound: any;
  enableOrderSound: any;
}

export const GlobalContext = createContext<GlobalContextProps | undefined>(
  undefined
);
